<template>
  <div class="tool-modal-webhook">
    <bp-input
      v-model="form.description"
      class="mb-5"
      label="Nome da configuração"
      placeholder="Digite um nome para sua configuração"
      :errors="errors.description"
    />
    <h4 class="mb-5">
      Quando acontecerem os seguintes eventos:
    </h4>

    <bp-collapse title="COMPRAS">
      <bp-checkbox-group v-model="form.events" :options="orderEvents" />
    </bp-collapse>
    <bp-collapse title="ASSINATURAS">
      <bp-checkbox-group v-model="form.events" :options="planEvents" />
    </bp-collapse>
    <bp-collapse title="OUTROS">
      <bp-checkbox-group v-model="form.events" :options="otherEvents" />
    </bp-collapse>

    <bp-select
      v-model="form.product_id"
      class="my-5"
      label="No produto:"
      placeholder="Selecionar produto"
      :disabled="!!form.id"
      :options="products.map(({ id, name }) => ({ id, name }))"
    />
    <bp-input
      v-model="form.url"
      class="mb-5"
      label="Enviar para a url:"
      placeholder="Digite"
      :errors="errors.url"
    />

    <div class="row">
      <div class="col-lg-6 mb-5">
        <bp-input
          v-model="form.internal_id"
          number
          placeholder="Digite"
          label="ID externo do produto (opcional)"
          :errors="errors.internal_id"
        />
      </div>
      <div class="col-lg-6 mb-5">
        <bp-input
          v-model="form.token"
          placeholder="Digite"
          label="Token da API (opcional)"
          :errors="errors.token"
        />
      </div>
    </div>

    <bp-switch v-model="form.extras.is_json" label="Enviar no formato JSON" />

    <footer-actions
      :loading="loading"
      :disabled="!isValid"
      @submit="submit"
      @cancel="$emit('close')"
    />
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  props: {
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(
        [
          "id",
          "url",
          "status",
          "description",
          "events",
          "token",
          "extras",
          "type",
          "internal_id",
          "product_id"
        ],
        {
          events: [],
          extras: { is_json: false }
        }
      ),
      loading: false
    };
  },
  computed: {
    ...mapState("integration", ["typeEvents"]),
    ...mapState("product", ["products"]),
    isValid() {
      return (
        this.form.events.length &&
        this.form.description &&
        this.form.product_id &&
        this.form.url
      );
    },
    orderEvents() {
      let types = [
        "approved",
        "chargeback",
        "generated_billet",
        "purchase_denied",
        "reversal",
        "pix_generated"
      ];
      return this.typeEvents.filter(t => types.includes(t.id));
    },
    planEvents() {
      let types = ["unsubscribe"];
      return this.typeEvents.filter(t => types.includes(t.id));
    },
    otherEvents() {
      let types = ["jumped_in_flight"];
      return this.typeEvents.filter(t => types.includes(t.id));
    }
  },
  methods: {
    submit() {
      this.loading = true;

      const data = {
        ...this.form,
        internal_id: this.form.internal_id
          ? parseInt(this.form.internal_id)
          : null
      };
      data.events = data.events.map(e => {
        return { event: e };
      });
      let action = "integration/postIntegration";
      if (this.integrationToEdit) {
        data.id = this.integrationToEdit.id;
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, data)
        .then(() => {
          setTimeout(() => {
            this.$message.success("A configuração foi salva!");
            this.$emit("refresh");
            this.$emit("close");
          }, 5000); // :(
        })
        .catch(error => {
          this.$message.error("Erro ao salvar configuração");
          this.errors = error.response.data;
          this.loading = false;
        });
    }
  },
  mounted() {
    if (this.integrationToEdit) {
      this.form = { ...this.integrationToEdit };
      this.form.events = this.integrationToEdit.events.map(e => e.event);
      this.form.product_id = this.integrationToEdit.events[0].product_id;
    }
  }
};
</script>
